/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationSignpostRightIcon16Solid = forwardRef('LocationSignpostRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.25 1.25a1.25 1.25 0 1 0-2.5 0V2h-4A1.75 1.75 0 0 0 1 3.75v3.5C1 8.216 1.784 9 2.75 9h4v5.5a1.25 1.25 0 1 0 2.5 0V9h2.775c.464 0 .91-.184 1.238-.513l2.28-2.28a1 1 0 0 0 0-1.414l-2.28-2.28A1.75 1.75 0 0 0 12.025 2H9.25v-.75Z" })));
});
